import { TelegramCategoryTreeResponseDto } from '@/generated';

export type CategoryMap = {
  [key: string]: TelegramCategoryTreeResponseDto;
};

export const getAllCategoryMap = (categories: TelegramCategoryTreeResponseDto[], resultMap = {}): CategoryMap => {
  for (let i = 0; i < categories.length; i++) {
    const selectedCategory = categories[i];
    resultMap[selectedCategory.id] = selectedCategory;

    if (Array.isArray(selectedCategory.children) && selectedCategory.children.length > 0) {
      getAllCategoryMap(selectedCategory.children, resultMap);
    }
  }

  return resultMap;
};

type CatMap = {
  [key: string]: {
    link: string;
    parentId: string | null;
  };
};

export const getNormalizedNameOfCategoriesPath = (categoryId: string, map: CatMap) => {
  const names: string[] = [];
  let currentId = categoryId;

  while (true) {
    const cat = map[currentId];
    if (!cat) {
      break;
    }
    names.unshift(cat.link);
    if (!cat.parentId) {
      break;
    }
    currentId = cat.parentId;
  }

  return names.join('/');
};
